export enum ChannelTypeEnum {
  Twilio = 1,
  Facebook = 2,
  Instagram = 3,
  WhatsApp = 4,
}
